import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../../components/Layout";
import { PageHero, ProseSection, EndCTA } from "../../components/PageParts";

export default function CabinetPantin() {
  const BC = [{ to: "/", label: "Accueil" }, { to: "/votre-seance", label: "Votre séance" }, { label: "Le cabinet à Pantin" }];
  return (
    <>
      <Seo
        title="Cabinet d'hypnose à Pantin (Métro Église de Pantin)"
        description="Le cabinet d'hypnose de Valentine DL se situe à Pantin, à 15 min de Paris, Métro Église de Pantin (ligne 5). Un espace calme et rassurant pour vos séances d'hypnose."
        canonical="https://www.parfaitsimparfaits.fr/votre-seance/cabinet-pantin"
      />
      <PageHero
        breadcrumb={BC}
        eyebrow="Sur place"
        title="Le cabinet d'hypnose"
        italic="à Pantin (93)"
        subtitle="Un espace calme, chaleureux et confidentiel, à 15 min de Paris."
      />
      <ProseSection>
        <h2 className="font-serif text-3xl text-sand-900 !mt-0">Un cadre pensé pour la détente</h2>
        <p>
          Le cabinet se trouve à <strong className="text-sand-900 font-medium">Pantin (Seine-Saint-Denis)</strong>,
          à proximité immédiate du <strong className="text-sand-900 font-medium">Métro Église de Pantin (ligne 5)</strong>,
          à environ <strong className="text-sand-900 font-medium">15 minutes de Paris</strong> par le métro.
          C'est un espace calme et lumineux, pensé pour que vous puissiez vous détendre pleinement.
          Si vous préférez rester chez vous, la{" "}
          <Link to="/votre-seance/en-ligne" className="text-[#B07A45] underline hover:text-sand-900">
            séance en visio
          </Link>{" "}
          est tout aussi qualitative.
        </p>
        <h2 className="font-serif text-3xl text-sand-900">Adresse et accès</h2>
        <p>
          L'adresse exacte vous est communiquée à la confirmation de rendez-vous. Un plan d'accès et
          les indications pratiques (transports, stationnement) vous sont fournis en même temps.
        </p>
        <h2 className="font-serif text-3xl text-sand-900">Bon à savoir avant votre venue</h2>
        <ul className="list-disc pl-5 space-y-2 marker:text-[#B07A45]">
          <li>Prévoir d'arriver <strong className="text-sand-900 font-medium">5 min en avance</strong>, sans plus (l'espace d'attente est réduit).</li>
          <li>Vêtements confortables recommandés — vous allez rester allongé·e ou assis·e un moment.</li>
          <li>Vous pouvez apporter une bouteille d'eau et une petite couverture si vous êtes frileux·se.</li>
          <li>Règlement en espèces ou par chèque en fin de séance.</li>
        </ul>
        <p className="!mt-8">
          Pour découvrir le déroulé complet, voir le{" "}
          <Link to="/votre-seance/deroulement" className="text-[#B07A45] underline hover:text-sand-900">
            déroulement d'une séance
          </Link>
          {" · "}
          <Link to="/votre-seance/tarifs" className="text-[#B07A45] underline hover:text-sand-900">
            Tarifs
          </Link>
          .
        </p>
      </ProseSection>
      <EndCTA testid="cabinet-end" />

      {/* Schema.org — LocalBusiness renforcé */}
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": ["LocalBusiness", "HealthAndBeautyBusiness"],
            name: "Parfaits Imparfaits — Cabinet d'hypnose à Pantin",
            description:
              "Cabinet d'hypnose régressive et spirituelle de Valentine DL, à Pantin (93), près du Métro Église de Pantin (ligne 5), à 15 minutes de Paris.",
            image: "https://www.parfaitsimparfaits.fr/img/logo-dark.webp",
            email: "v.parfaitsimparfaits@gmail.com",
            url: "https://www.parfaitsimparfaits.fr/votre-seance/cabinet-pantin",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Pantin",
              addressRegion: "Île-de-France",
              postalCode: "93500",
              addressCountry: "FR",
            },
            areaServed: ["Pantin", "Paris", "Île-de-France"],
          }),
        }}
      />
    </>
  );
}
